import { useEffect, useState } from "react";
import { matchMediaQuery } from "@crehana/utils";
import debounce from "lodash/debounce";
const getVisibleHeight = ({ elementHeight, scrolledValue })=>scrolledValue > elementHeight ? 0 : elementHeight - scrolledValue;
const useVisibleHeight = ({ position, theme, topBannerIsOpen })=>{
    const navHeight = theme.nav.height;
    const [scrollTop, setScrollTop] = useState(0);
    const [topBannerHeight, setTopBannerHeight] = useState(0);
    const [visibleHeight, setVisibleHeight] = useState({
        mainMenu: {
            xs: navHeight.xs,
            sm: navHeight.sm,
            md: navHeight.md,
            lg: navHeight.lg
        },
        topBanner: 0
    });
    useEffect(()=>{
        const onScroll = debounce(()=>{
            setScrollTop(document.documentElement.scrollTop);
        }, 100);
        window.addEventListener('scroll', onScroll);
        return ()=>{
            window.removeEventListener('scroll', onScroll);
        };
    }, []);
    const calculateTopBannerHeight = ()=>{
        const topBannerElement = document.getElementById('mainMenuTopBanner');
        setTopBannerHeight(topBannerElement ? topBannerElement.clientHeight : 0);
    };
    useEffect(()=>calculateTopBannerHeight(), [
        topBannerIsOpen
    ]);
    useEffect(()=>{
        const nativeMediaQueryList = matchMediaQuery('sm');
        if ('function' == typeof nativeMediaQueryList.addEventListener) nativeMediaQueryList.addEventListener('change', calculateTopBannerHeight);
        else if ('function' == typeof nativeMediaQueryList.addListener) nativeMediaQueryList.addListener(calculateTopBannerHeight);
        return ()=>{
            if ('function' == typeof nativeMediaQueryList.removeEventListener) nativeMediaQueryList.removeEventListener('change', calculateTopBannerHeight);
            else if ('function' == typeof nativeMediaQueryList.removeListener) nativeMediaQueryList.removeListener(calculateTopBannerHeight);
        };
    }, []);
    useEffect(()=>{
        const scrolledValue = document.documentElement.scrollTop;
        const visibleNavHeight = 'sticky' !== position && scrollTop ? {
            xs: getVisibleHeight({
                elementHeight: navHeight.xs,
                scrolledValue
            }),
            sm: getVisibleHeight({
                elementHeight: navHeight.sm,
                scrolledValue
            }),
            md: getVisibleHeight({
                elementHeight: navHeight.md,
                scrolledValue
            }),
            lg: getVisibleHeight({
                elementHeight: navHeight.lg,
                scrolledValue
            })
        } : navHeight;
        const topBannerVisibleHeight = topBannerHeight ? getVisibleHeight({
            elementHeight: topBannerHeight,
            scrolledValue
        }) : 0;
        setVisibleHeight({
            mainMenu: {
                xs: visibleNavHeight.xs + topBannerVisibleHeight,
                sm: visibleNavHeight.sm + topBannerVisibleHeight,
                md: visibleNavHeight.md + topBannerVisibleHeight,
                lg: visibleNavHeight.lg + topBannerVisibleHeight
            },
            topBanner: topBannerVisibleHeight
        });
    }, [
        scrollTop,
        position,
        navHeight,
        topBannerHeight
    ]);
    return {
        mainMenuVisibleHeight: visibleHeight.mainMenu,
        topBannerVisibleHeight: visibleHeight.topBanner
    };
};
const hooks_useVisibleHeight = useVisibleHeight;
export default hooks_useVisibleHeight;
